import _ from 'lodash';

import AutoAcceptedSessionNotification from 'models/notification/auto_accepted_session_notification';
import Communicator from 'models/communicator';
import ConversationConverter from 'scripts/application/dto_converters/conversation_converter';
import ConversationItem, { getTextForContent } from 'models/conversation_item';
import ConversationItemType from 'models/conversation_item_type';
import DeclinedReassignedSessionNotification from 'models/notification/declined_reassigned_session_notification';
import InteractionType from 'models/interaction_type';
import { MessageChannelType } from 'models/conversation_message';
import { NotificationSoundType } from 'actions/notification/lib/notification_constants';
import playNotificationSound from 'actions/notification/lib/play_notification_sound';
import RoutingItem from 'models/routing_item';
import RoutingItemType from 'models/routing_item_type';

export default class ActiveSessionCustomerHistoryObserver {
  constructor(context) {
    this.context = context;
  }

  handleReceiveCurrentConversationItems({ customerId, currentItemsDto }) {
    let customerSession = this.context.stores.activeSessions.findBy({ customer: { id: customerId } });
    if (!customerSession) {
      return;
    }

    let customerItem = _.find(
      currentItemsDto.latestNonAutomaticInitiatorItemsOfEachType,
      i =>
        sessionTypeForContent(i.content) === _.get(customerSession.queueItem.getLatestSession(), 'type') &&
        i.initiator.type === Communicator.CUSTOMER
    );
    if (!customerItem) {
      return;
    }

    let messageText = getTextForContent(customerItem.content);
    customerSession.update({ messageText });
    this.context.stores.activeSessions.replace(customerSession);

    let autoAcceptNotification = this.context.stores.notifications.findBy({ id: customerSession.id });
    if (autoAcceptNotification && autoAcceptNotification instanceof AutoAcceptedSessionNotification) {
      autoAcceptNotification.updateMessageText(messageText);
      this.context.stores.notifications.replace(autoAcceptNotification);
    }
  }

  handleUpdateConversation({ conversationDto }) {
    this.updateActiveSession(conversationDto);
  }

  handleUpdateConversationItem({ customerId, conversationItemDto }) {
    let conversationItem = ConversationItem.fromJs(conversationItemDto);
    if (
      !(
        conversationItem.content instanceof RoutingItem &&
        conversationItem.content.itemType === RoutingItemType.OFFER_CONFLICT
      )
    ) {
      return;
    }

    let currentAgent = this.context.stores.currentAgent.get();
    if (conversationItem.content.assignee.agentId !== currentAgent.id) {
      return;
    }

    let activeSession = this.context.stores.activeSessions.findBy({ customer: { id: customerId } });
    if (!activeSession) {
      return;
    }

    this.context.stores.notifications.addOrReplace(
      DeclinedReassignedSessionNotification.create({
        conversationId: activeSession.queueItem.conversationId,
        profile: activeSession.customer,
        transferee: conversationItem.content.assigneeWas,
        sessionType: _(activeSession.queueItem.getLatestSession()).get('type'),
      })
    );

    playNotificationSound(NotificationSoundType.DECLINED_SESSION_REASSIGNMENT);
  }

  handleReceiveConversations({ conversationsDto }) {
    conversationsDto.forEach(conversationDto => this.updateActiveSession(conversationDto));
  }

  updateActiveSession(conversationDto) {
    const conversation = ConversationConverter.fromDto(conversationDto);
    const activeSession = this.context.stores.activeSessions.findBy({ queueItem: { conversationId: conversation.id } });
    if (activeSession) {
      activeSession.update({ conversationUpdatedAt: conversation.updatedAt });
      this.context.stores.activeSessions.replace(activeSession);
    }
  }
}

export function sessionTypeForContent(content) {
  switch (content.type) {
    case ConversationItemType.CHAT_MESSAGE:
      return InteractionType.CHAT;
    case ConversationItemType.EMAIL:
      return InteractionType.EMAIL;
    case ConversationItemType.FB_MESSAGE_INCOMING:
    case ConversationItemType.FB_MESSAGE_OUTGOING:
      return InteractionType.FB_MESSENGER;
    case ConversationItemType.SMS:
      return InteractionType.SMS;
    case ConversationItemType.CONVERSATION_MESSAGE:
      switch (content.channel) {
        case MessageChannelType.INSTAGRAM_DIRECT:
          return InteractionType.INSTAGRAM_DIRECT;
        case MessageChannelType.TWITTER:
          return InteractionType.TWITTER;
        case MessageChannelType.WHATSAPP:
          return InteractionType.WHATSAPP;
        default:
          return '';
      }
    default:
      return '';
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/concurrent_messaging/active_session_customer_history_observer.js